/** @flow */
import moment from 'moment';
import api from 'common/services/api';
import Estimation from 'common/modules/proposition/domain/estimation';
import AgeRangeReaches from 'common/domain/AgeRangeReaches';
import GenderReach from 'common/domain/GenderReach';
import AgeRangeReachesAPIHelper from 'common/helpers/AgeRangeReachesAPIHelper';
import DateRange from 'common/domain/DateRange';
import AntennaReach from 'statsradio/domain/AntennaReach';
import GeolocationReach from 'statsradio/modules/dashboard/domain/GeolocationReach';
import type { SalesFlyer } from '../domain/sales';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';


class SalesApi {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async getSalesFlyer(callSign: string, token: string, dateRange: DateRange, centralMarket: ?CentralMarket): Promise<SalesFlyer> {
    const { from, to } = dateRange.toISO();
    const { data } =
      await api.get(`/sales/${callSign}/flyer`, {
        from,
        to,
        centralMarket: centralMarket && centralMarket.reference,
      }, { headers: this.buildHeaders(token) });

    const ages = AgeRangeReachesAPIHelper.flatToJson(data.ages, data.agesMetadata);

    return {
      reach: data.reach,
      averageReach: data.averageReach,
      listeningTime: data.listeningTime,
      averageListeningTime: data.averageListeningTime,
      listeningTimePerPerson: data.listeningTimePerPerson,
      averageListeningTimePerPerson: data.averageListeningTimePerPerson,
      ages: AgeRangeReaches.parse(ages),
      genders: GenderReach.parse(data.genders),
      from: moment(data.from),
      to: moment(data.to),
      antennaReach: data.antennaReach ? AntennaReach.parse(data.antennaReach) : undefined,
      reachByRegion: data.reachByRegion ? data.reachByRegion.map(geo => GeolocationReach.parse(geo)) : undefined,
    };
  }

  async removeSalesEstimation(token: string, callSign: string, reference: string): Promise<*> {
    await api.del(`/${callSign}/sales/estimations/${reference}`, { headers: this.buildHeaders(token) });
  }

  async fetchHistory(token: string, callSign: string): Promise<Estimation[]> {
    const { data } = await api.get(`/${callSign}/sales/estimations/history`, {}, { headers: this.buildHeaders(token) });
    return data
      .map(x => ({
        ...x,
        ageGroup: AgeRangeReachesAPIHelper.flatToJson(x.ageGroup, x.ageGroupMetadata),
      }))
      .map(x => Estimation.parse(x));
  }
}

export default new SalesApi();



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/services/SalesApi.js